module.exports = __webpack_public_path__ + "static/media/master_card.295bdb32.svg";